import PageWithTitleMixin from 'mixins/PageWithTitleMixin'

export const steps = ['search', 'results', 'make']
export default {
    mixins: [PageWithTitleMixin],

    computed: {
        pageTitle() {
            return this.$t('pages.referrals.new.title')
        },

        stepIndex() {
            return steps.findIndex((step) => step === this.$route.params.step)
        },

        pageBreadcrumbs() {
            return steps.reduce((breadcrumbs, step, index) => {
                return index <= this.stepIndex
                    ? breadcrumbs.concat([
                          {
                              label: this.$t(`pages.referrals.new.breadcrumbs.${step}`),
                              route:
                                  index !== this.stepIndex
                                      ? {
                                            name: `pool.new.${step}`,
                                            query: this.$route.params.originalQuery || this.$route.query,
                                        }
                                      : undefined,
                          },
                      ])
                    : breadcrumbs
            }, [])
        },
    },

    methods: {
        goToNextStep() {
            this.$router.push({ name: `pool.new.${steps[this.stepIndex + 1]}` })
        },
    },
}
